// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"lF-z","expressButtonContainerWithPayPal":"mF-z","expressButton":"nF-z","or":"oF-z"};